<div class="box sankey bordered" id="sankey"></div>

<div
  #desc
  [ngClass]="{'active': NoteVisible}"
  [style.left]="clientX"
  [style.top]="clientY"
  class="description"
>
  <span class="tot">Amount: {{Amount}}</span>
  <br />
  <span class="year">accrued: {{YearAccrued}}</span>
  <br />
  <span class="year">payed: {{YearPayed}}</span>
</div>
